<template>
  <div class="default-bg wallet text-center">
    <top-navigation class="top-navigation" :show-avatar="false">
      <div slot="right" class="logo">
        <img src="../assets/img/ngkids-photo_ark.png">
      </div>
    </top-navigation>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="m-4">YOUR <span class="orange">WALLET</span></h1>
          <p class="m-4">This is where you’ll find everything you’ve unlocked during your games and can see your place on the leaderboard.</p>
        </div>
      </div>
    </div>
    <div class="container-fluid pl-1 pr-1">
      <div class="row stats">
        <div class="col-3 text-center middle">
          <img class="avatar-shoe-image" :src="avatar.avatarShoes.avatarShoeImage" />
        </div>
        <div class="col-2 pl-0 pr-1 text-center">
          <router-link class="stats-link" to="/fact-cards">
            <img class="mb-4" src="../assets/img/cards.png"/>
            <h3 class="mb-4">YOUR <br />CARDS</h3>
            <h2 class="mb-4">{{ factCards.length }} / {{ factCardsList.length }}</h2>
          </router-link>
        </div>
        <div class="col-2 text-center">
          <router-link to="/fact-files">
            <img class="mb-4" src="../assets/img/files.png"/>
            <h3 class="mb-4">FACT <br />FILES</h3>
            <h2 class="mb-4">{{ factFiles.length }} / {{ factFilesList.length }}</h2>
          </router-link>
        </div>
        <div class="col-2 pl-1 pl-1 text-center">
          <router-link to="/leaderboard">
            <img class="mb-4" src="../assets/img/leaderboard.png"/>
            <h3 class="mb-4">HIGH <br />SCORES</h3>
            <h2 class="mb-4">{{ score | numberWithCommas }}</h2>
          </router-link>
        </div>
        <div class="col-3 text-center middle p-0">
          <img class="avatar-image" :src="avatar.avatarImage" />
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <router-link class="btn btn-primary mx-auto ng-default-btn mx-auto" to="/selection">BACK TO GAMES</router-link>
        </div>
      </div>
    </div>
    <div class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-4">
        </div>
        <div class="col-4 loading-text-wrapper">
        </div>
        <div class="col-4 logo">
          <img src="../assets/img/logo.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import TopNavigation from '../components/TopNavigation'

export default {
  components: {
    TopNavigation
  },
  name: 'Wallet',
  computed: {
    ...mapGetters(['score', 'factCards', 'factFiles', 'factFilesList', 'factCardsList', 'avatar'])
  },
  mounted () {
    this.setCardDiff()
  },
  methods: { ...mapMutations(['setCardDiff']) },
  filters: {
    numberWithCommas (number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style scoped>
  .stats a {
    color: #ffffff;
  }

  h1 {
    font-size: 5vh;
  }

  h1, p {
    text-align: center;
  }

  h1 {
    margin-top: 1vh;
    font-family: "Geograph-Black";
  }

  h2 {
    font-size: 6vh;
    color: #ffbf00;
    font-family: "Geograph-Bold";
  }

  h3 {
    font-size: 3.4vh;
  }

  p {
    font-size: 3.2vh;
    font-family: "Geograph-Medium";
  }

  .col-2 img {
    height: 7vh;
  }

  .wallet {
    color: #ffffff;
  }

  .stats {
    font-font: "Geograph Black";
  }

  .avatar-shoe-image {
    width: 100%;
  }

  .avatar-image {
    width: 10vw;
  }

  .middle {
    align-items: center;
  }
</style>
